import React from "react"
import { Source, Layer } from "react-map-gl"
import type { FillLayer, LineLayer } from "react-map-gl"
import type GeoJSON from "geojson"

export const FILL_LAYER_SUFFIX = "_fill_layer"

export const LINE_LAYER_SUFFIX = "_line_layer"

interface FillPaint {
  fillColor?: string
  fillOpacity?: number
}

export interface LinePaint {
  lineColor?: string
  lineWidth?: number
  lineOpacity?: number
  lineDasharray?: number[]
}

interface GeoJSONLayerProps {
  id: string
  data: GeoJSON.Feature | GeoJSON.FeatureCollection
  fillPaint?: FillPaint
  linePaint?: LinePaint
  beforeId?: string
}

const GeoJSONLayer: React.FC<GeoJSONLayerProps> = ({ id, data, fillPaint, linePaint, beforeId }) => {
  const fillLayer: FillLayer = {
    id: `${id}${FILL_LAYER_SUFFIX}`,
    type: "fill",
    paint: {
      "fill-color": fillPaint?.fillColor ?? "#000",
      "fill-opacity": fillPaint?.fillOpacity ?? 1,
    },
  }

  const lineLayer: LineLayer = {
    id: `${id}${LINE_LAYER_SUFFIX}`,
    type: "line",
    paint: {
      "line-color": linePaint?.lineColor ?? "#000",
      "line-width": linePaint?.lineWidth ?? 1,
      "line-opacity": linePaint?.lineOpacity ?? 1,
      "line-dasharray": linePaint?.lineDasharray ?? [1],
    },
  }

  return (
    <Source type="geojson" data={data}>
      <Layer {...(beforeId ? { beforeId } : {})} {...fillLayer} />
      <Layer {...(beforeId ? { beforeId } : {})} {...lineLayer} />
    </Source>
  )
}

export default GeoJSONLayer
